export default __webpack_public_path__ + "static/media/BEST_WISHES.832e84e0.png";